const SCROLL_REVEAL_OPTIONS = {
  rootMargin: '0px 0px -12% 0px',
  threshold: 0.15,
};

const SCROLL_REVEAL_GROUPS = [
  {
    root: '.product-description-section .rte',
    rte: true,
  },
  {
    root: '.simple-product-section',
    items: '.product-card-item, .view-all-wrapper',
  },
  {
    root: '.about-simple-section',
    items: '.about-simple-image, .about-simple-text-group',
  },
  {
    root: '.brand-section',
    items: '.brand-info-container, .brand-description-sp, .product-item, .collection-link',
  },
  {
    root: '[id*="featured_blog"]',
    items: '.column-grid .column-item',
  },
];

function getRteRevealElements(rte) {
  const blockSelector =
    'p, h1, h2, h3, h4, h5, h6, ul, ol, img, blockquote, table, figure, hr, iframe, video';
  const directChildren = Array.from(rte.querySelectorAll(':scope > *')).filter(
    (element) => element.textContent.trim() !== '' || element.tagName === 'IMG'
  );

  if (directChildren.length > 1) {
    return directChildren;
  }

  if (directChildren.length === 1) {
    const wrapper = directChildren[0];
    const wrapperTag = wrapper.tagName.toLowerCase();

    if (wrapperTag === 'div' || wrapperTag === 'section' || wrapperTag === 'article') {
      const nested = Array.from(wrapper.querySelectorAll(`:scope > ${blockSelector}`)).filter(
        (element) => element.textContent.trim() !== '' || element.tagName === 'IMG'
      );
      if (nested.length) return nested;
    }
  }

  return Array.from(rte.querySelectorAll(blockSelector)).filter(
    (element) => element.textContent.trim() !== '' || element.tagName === 'IMG'
  );
}

function observeScrollRevealElements(elements) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        requestAnimationFrame(() => {
          entry.target.classList.add('scroll-reveal--ready');
        });
        observer.unobserve(entry.target);
      });
    },
    SCROLL_REVEAL_OPTIONS
  );

  elements.forEach((element) => {
    element.classList.add('scroll-reveal');
    observer.observe(element);
  });
}

function initScrollRevealGroup(group, scope = document) {
  scope.querySelectorAll(group.root).forEach((container) => {
    if (container.dataset.revealInit === 'true') return;
    container.dataset.revealInit = 'true';

    const elements = group.rte
      ? getRteRevealElements(container)
      : Array.from(container.querySelectorAll(group.items));

    if (!elements.length) return;

    observeScrollRevealElements(elements);
  });
}

function initScrollReveal(scope = document) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  SCROLL_REVEAL_GROUPS.forEach((group) => initScrollRevealGroup(group, scope));
}

document.addEventListener('DOMContentLoaded', () => initScrollReveal());

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initScrollReveal(event.target);
  });
}
